import script from "./TestForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./TestForm.vue?vue&type=script&setup=true&lang=ts"

import "./TestForm.vue?vue&type=style&index=0&id=40d45af6&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40d45af6"]])

export default __exports__